<template>
  <div class="grid-container pos-r">
    <AgGridVue
      style="width: 100vw; height: calc(100vh - 90px);"
      class="ag-theme-alpine"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :row-selection="rowSelection"
      :allow-context-menu-with-control-key="true"
      :get-context-menu-items="getContextMenuItems"
      :framework-components="frameworkComponents"
      :row-height="contentType.rowHeight"
      :row-drag-managed="true"
      :animate-rows="true"
      :suppress-row-drag="suppressRowDrag"
      :modules="modules"
      @grid-ready="onGridReady"
      @cell-double-clicked="onCellDoubleClicked"
      @selectionChanged="selectionChanged"
      @row-drag-move="onRowDragMove"
    ></AgGridVue>
  </div>
</template>

<script>
// import Vue from 'vue/dist/vue.esm.js'
import { AgGridVue } from 'ag-grid-vue'
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model'

import AirlineLogoRenderer from '@components/grid/airlineLogoRenderer.js'
import EnabledDisabledRenderer from '@components/grid/enableDisabledRenderer.js'

import  hhmmCellRenderer  from '@components/grid/timeCellRenderer.js'
import  dayOfWeekCellRenderer  from '@components/grid/dayOfWeekCellRenderer.js'

export default {
  components: {
    AgGridVue,
  },
  props: {
    colDef: {
      type: Array,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    selected: {
      type: Array,
      required: true,
    },
    contentType: {
      type: Object,
      required: true,
    },
    quickFilter: {
      type: String,
    },
  },
  data() {
    return {
      columnDefs: null,
      rowData: null,
      rowSelection: null,
      gridApi: null,
      gridOptions: null,
      frameworkComponents: null,
      modules: [],
      filters: [],
    }
  },
  computed: {
    suppressRowDrag() {
      return false
    },
  },
  watch: {
    data(data) {
      this.rowData = data
      if (this.selected.length) {
        this.setSelectedRow(this.selected[0].Id)
      }
    },
    loading(loading) {
      if (loading) {
        this.gridOptions.api.showLoadingOverlay()
      } else {
        this.gridOptions.api.hideOverlay()
      }
    },
    quickFilter: {
      handler(filterTerm) {
        this.quickFilterFunc(filterTerm)
      },
    },
  },
  beforeMount() {
    this.gridOptions = {}

    this.columnDefs = this.colDef

    this.frameworkComponents = {
      logoRenderer: AirlineLogoRenderer,
      boolRenderer: EnabledDisabledRenderer,
      hhmmRenderer: hhmmCellRenderer,
      dayOfWeek: dayOfWeekCellRenderer,
    }

    this.rowData = this.data

    this.rowSelection = 'single'

    this.modules = [ClientSideRowModelModule]
  },
  mounted() {
    this.gridApi = this.gridOptions.api

    this.gridOptions.api.showLoadingOverlay()
  },
  methods: {
    onBtnExport(params) {
      this.gridApi.exportDataAsCsv(params)
    },
    onGridReady(params) {
      this.gridApi = params.api
      this.columnApi = params.columnApi
    },
    getSelectedRows() {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
      return selectedData
    },
    getRows() {
      const data = []
      this.gridApi.forEachNode(function(rowNode, index) {
        data.push(rowNode.data)
      })
      return data
    },
    onCellDoubleClicked(e) {
      this.$emit('onCellDoubleClicked', e)
    },
    selectionChanged() {
      this.$emit('onSelectionChanged', this.getSelectedRows())
    },
    setSelectedRow(id) {
      if (!id) {
        return
      }
      this.$nextTick(() => {
        this.gridApi.forEachNode((node) => {
          if (node.data.Id === id) {
            node.setSelected(true, false, true)
          }
        })
      })
    },
    getContextMenuItems(params) {
      var result = [
        {
          name: this.$t('Edit'),
          action: () => {
            this.$emit('edit', params.node.data)
          },
        },
        {
          name: this.$t('Delete'),
          action: () => {
            this.$emit('delete', params.node.data)
          },
        },
        {
          name: this.$t('CreateCopy'),
          action: () => {
            this.$emit('copy', params.node.data)
          },
        },
        {
          name: 'Always Disabled',
          disabled: true,
          tooltip:
            'Very long tooltip, did I mention that I am very long, well I am! Long!  Very Long!',
        },

        'separator',

        'copy',
      ]
      return result
    },
    onRowDragMove(event) {
      // Moving Elements
      const nodeMoving = event.node
      const nodeOver = event.overNode

      // Order has changed?
      const reorderRequired = nodeMoving !== nodeOver
      if (reorderRequired) {
        // Get node data
        const movingData = nodeMoving.data
        const overData = nodeOver.data
        // Get index of moving data
        const fromIndex = this.data.indexOf(movingData)
        const toIndex = this.data.indexOf(overData)
        // Update the a copy of the data
        const dataCopy = this.data.slice()
        moveInArray(dataCopy, fromIndex, toIndex)

        const setOrderData = dataCopy.map((s) => s.FieldName)
        this.$emit('setOrderData', setOrderData)
      }
      function moveInArray(arr, fromIndex, toIndex) {
        var element = arr[fromIndex]
        arr.splice(fromIndex, 1)
        arr.splice(toIndex, 0, element)
      }
    },
    quickFilterFunc(filterTerm) {
      this.gridApi.setQuickFilter(filterTerm)
    },
  },
}
</script>

<style lang="scss">
.ag-row {
  transition: all 0 !important;
  svg {
    width: 20px !important;
  }
}

.ag-header-cell-label-center {
  justify-content: center;
}

.ag-cell.ag-cell-value {
  &.br {
    border-right-color: #dde2eb;
  }
}

$global: #3f51b5;
.global-fill {
  fill: $global;
}
.country-fill {
  fill: adjust-hue($global, 100) !important;
}
.station-fill {
  fill: adjust-hue($global, 260) !important;
}

.ag-row-selected {
  .text-success,
  .text-secondary {
    color: white;
  }
}

.filter-panel {
  position: absolute;
  top: 0;
  background: white;
  width: 340px;
  right: 0;
  height: 100%;
  border-left: 1px solid #dde2eb;
  max-height: 100%;
  overflow-x: auto;
  z-index: 998;
  .filter-panel-header {
    background: #f8f9fa;
    padding: 1rem;
    border-bottom: 1px solid #dde2eb;
  }
}

.pos-r {
  position: relative;
}
</style>
